import * as actionTypes from "./types";

export const updateUserToken = (data) => ({
  type: actionTypes.UPDATE_USER_TOKEN,
  payload: data,
});

export const updateRefreshToken = (data) => ({
  type: actionTypes.UPDATE_REFRESH_TOKEN,
  payload: data,
});

export const updateDrawerOpen = (data) => ({
  type: actionTypes.UPDATE_DRAWER_OPEN,
  payload: data,
});

export const updateRestaurantData = (data) => ({
  type: actionTypes.UPDATE_RESTAURANT_DATA,
  payload: data,
});

export const updateUserId = (data) => ({
  type: actionTypes.UPDATE_USER_ID,
  payload: data,
});

export const updateFeaturesList = (data) => ({
  type: actionTypes.UPDATE_FEATURES_LIST,
  payload: data,
});

export const logOut = () => ({
  type: actionTypes.LOG_OUT,
});
export const updateRestaurantCourseList = (data) => ({
  type: actionTypes.UPDATE_RESTAURANT_COURSE_LIST,
  payload: data,
});
export const updateRestaurantCategoryList = (data) => ({
  type: actionTypes.UPDATE_RESTAURANT_CATEGORY_LIST,
  payload: data,
});
export const updateRestaurantMenuList = (data) => ({
  type: actionTypes.UPDATE_RESTAURANT_MENU_LIST,
  payload: data,
});
export const updateUserRole = (data) => ({
  type: actionTypes.UPDATE_USER_ROLE,
  payload: data,
});
export const updateUserDetail = (data) => ({
  type: actionTypes.UPDATE_USER_DETAIL,
  payload: data,
});
export const updateUserRolesList = (data) => ({
  type: actionTypes.UPDATE_USER_ROLES_LIST,
  payload: data,
});
export const updateSelectedMenuCategory = (data) => ({
  type: actionTypes.UPDATE_SELECTED_MENU_CATEGORY,
  payload: data,
});